import React, { Component } from 'react';
import SimpleBar from 'simplebar-react';
import 'simplebar/dist/simplebar.min.css';
import Modal from './Modal';

const homePageImages = [
	{
		title: '5 Rotating Banners',
		imgURL: 'https://cdn.couponology.com/images/mediakit-homepage.jpg',
		overlayButton: true,
		modalContent: <SimpleBar className='modal-content-container'>
						<h3 className='heading'>Homepage Rotating Banners</h3>
						<div className='row'>
							<div className='col-md-12 content'>
								<div style={{display: 'inline-block'}} className='text-left'>
									<img className='homepage-banner-desktop-img-sample' src='https://cdn.couponology.com/images/mediakit-homepage-desktop-placement.jpg' alt='Homepage Banner' />
									<p className='img-properties'>
										A desktop banner image containing text, offer codes, or logos. <br />
										<strong>Dimensions (pixels):</strong> 1920 width x 400 height
										<br />
										<strong>Size:</strong> 80KB max
									</p>
								</div>
								<div style={{display: 'inline-block', marginTop: '10px'}} className='text-left'>
									<img className='homepage-banner-mobile-img-sample' src='https://cdn.couponology.com/images/mediakit-homepage-mobile-placement.jpg' alt='Homepage Mobile Banner' />
									<p className='img-properties'>
										A mobile banner image containing text, offer codes, or logos. <br />
										<strong>Dimensions (pixels):</strong> 1200 width x 400 height
										<br />
										<strong>Size:</strong> 70KB max
									</p>
								</div>
							</div>
							<div className='col-md-12 content'>
								<h4>Product Description:</h4>
								<p>
									With five placement slots, the homepage rotating banner represents the absolute best placement opportunity uniquely designed to showcase your product or store. By placing your banner on the homepage and above-the-fold, this fantastic opportunity can serve to drive a tremendous amount of traffic to your store or product offering.
								</p>
								<p>
									With more customers shopping via mobile devices, this placement also offers the ability to display mobile-ready, optimized banners, and serve these banners with speed and efficiency.
								</p>
								<p>
									Reach a wider audience, increase brand awareness, and generate incredible revenue with the homepage rotating banner.
								</p>
							</div>
						</div>
					  </SimpleBar>
	},
	{
		title: '15 Best Online Deals',
		imgURL: 'https://cdn.couponology.com/images/mediakit-homepage-bol.jpg',
		overlayButton: true,
		modalContent: <SimpleBar className='modal-content-container'>
						<h3 className='heading'>Best Online Deals</h3>
						<div className='row'>
							<div className='col-md-6 col-md-push-6 text-center content'>
								<div style={{display: 'inline-block'}} className='text-left'>
									<img className='bol-img-sample' src='https://cdn.couponology.com/images/mediakit-homepage-bol-placement.jpg' alt='Best Online' />
									<p className='img-properties'>
										A lifestyle image with no text, offer codes, or logos. <br />
										<strong>Dimensions (pixels):</strong> 250 width x 150 height
										<br />
										<strong>Size:</strong> 10KB max
									</p>
								</div>
							</div>
							<div className='col-md-6 col-md-pull-6 content'>
								<h4>Product Description:</h4>
								<p>
									With 15 placement opportunities, across 3 rows, the best online deals serve to achieve maximum revenue growth by showcasing your best offers, front-and-center, on our home page.
								</p>
								<p>
									Bring more attention to your established brand and feature your best deals or sitewide offers in the first row. Make your brand more familiar to a wider audience with a second row placement. Or introduce your brand to a new audience with a third row placement.
								</p>
								<p>
									All placements are designed to increase traffic, convert potential customers into new, loyal shoppers and increase growth and revenue.
								</p>
							</div>
						</div>
					</SimpleBar>
	},
	{
		title: '8 Exclusive Deals',
		imgURL: 'https://cdn.couponology.com/images/mediakit-homepage-exclusivedeals.jpg',
		overlayButton: true,
		modalContent: <SimpleBar className='modal-content-container'>
						<h3 className='heading'>Exclusive Deals</h3>
						<div className='row'>
							<div className='col-md-6 col-md-push-6 text-center content'>
								<div style={{display: 'inline-block'}} className='text-left'>
									<img className='exclusive-img-sample' src='https://cdn.couponology.com/images/mediakit-homepage-exclusivedeals-placement.jpg' alt='Exclusive Deals' />
									<p className='img-properties'>
										A product image with no text, offer codes, or logos. <br />
										<strong>Dimensions (pixels):</strong> 245 width x 240 height
										<br />
										<strong>Size:</strong> 20KB max
									</p>
								</div>
							</div>
							<div className='col-md-6 col-md-pull-6 content'>
								<h4>Product Description:</h4>
								<p>
									With 8 placement opportunities, our exclusive deals are your chance to showcase a beautiful product image placed strategically on the homepage.
								</p>
								<p>
									This unique placement provides every advertiser the opportunity to promote specific products, offer great deals, and achieve exceptional performance. 
								</p>
								<p>
									Provide a great customer experience, generate revenue, and increase sales with a product placement in the exclusive deals section of our homepage.
								</p>
							</div>
						</div>
					</SimpleBar>
	},
	{
		title: '3 Product Deals',
		imgURL: 'https://cdn.couponology.com/images/mediakit-homepage.jpg',
		overlayButton: false,
		modalContent: <SimpleBar className='modal-content-container'>
						<h3 className='heading'>Product Deals</h3>
						<div className='row'>
							<div className='col-md-6 col-md-push-6 text-center content'>
								<div style={{display: 'inline-block'}} className='text-left'>
									<img className='exclusive-img-sample' src='https://via.placeholder.com/245x240?text=Product+Deals+Placeholder' alt='Product Deals' />
									<p className='img-properties'>
										A product image with no text, offer codes, or logos. <br />
										<strong>Dimensions (pixels):</strong> xxx width x xxx height
										<br />
										<strong>Size:</strong> 20KB max
									</p>
								</div>
							</div>
							<div className='col-md-6 col-md-pull-6 content'>
								<h4>Product Description:</h4>
								<p>
									Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.
								</p>
								<p>
									Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.
								</p>
							</div>
						</div>
					</SimpleBar>
	}
];

export default class HomePage extends Component {
	constructor(props) {
		super(props);
		this.state = { isModalOpen: false, modalContent: '' };
	}
	
	  toggleModal = () => {
			this.setState({
				isModalOpen: !this.state.isModalOpen
			});
		}
		
		addModalContent = (modal_content) => {
			this.setState({
				modalContent: modal_content
			});
		}

	render() {
		return(
			<div className='row min-height-400 border component' id='home'>
				<div className='col-md-12 text-center'>
					<h2 className='section-heading'>40 Unique Homepage Placements</h2>
					<ul className='sub-heading-list'>
						<li>
							<span>Fresh clean modern layout</span>
						</li>
						<li>
							<span className='glyphicon glyphicon-stop' aria-hidden='true'></span>
							<span>Fully responsive mobile design</span>
						</li>
						<li>
							<span className='glyphicon glyphicon-stop' aria-hidden='true'></span>
							<span>Captivating product &amp; lifestyle images</span>
						</li>
					</ul>
				</div>
				{homePageImages.map((homePageImage, key) => 
					<div className='col-md-3 text-center' key={key}>
						<h3>{homePageImage.title}</h3>
						<div className='img-container'>
							<img src={homePageImage.imgURL} alt='homepage' />
							<div className='overlay' />
							<div className='btn-container'>
								{homePageImage.overlayButton ? <button className='btn-1' onClick={() => {this.toggleModal(); this.addModalContent(homePageImage.modalContent);}}>See details</button> : <button className='btn-1 no-click'>Coming Soon</button>}
							</div>
						</div>
					</div>
				)}

				{this.state.isModalOpen ? 
					<Modal
						text={this.state.modalContent}
						open={this.state.isModalOpen}
						onClose={this.toggleModal.bind(this)}
					/> : ''}
			</div>
		);
	}
}